import { DeleteOutline } from '@mui/icons-material'
import { IconButton, styled, Tooltip } from '@mui/material'
import { modalVar } from '../../../../../providers/apollo/cache'
import useBucket from '../../../hooks/useBucket'
import useBucketConvertProgress from '../../../hooks/useBucketConvertProgress'
import useBucketMigrationProgress from '../../../hooks/useBucketMigrationProgress'
import useSelectedMedia from '../../../hooks/useSelectedMedia'

const PillButton = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  color: '#fff',
  fontWeight: 500,
  fontSize: '0.875rem',
  cursor: 'pointer',
  gap: 8
})

export default function MediaDeletePillButton() {
  const { selectedMedia } = useSelectedMedia()
  const { bucketUser } = useBucket()
  const mediaDeletePermission = bucketUser?.permissions?.mediaDelete
  const isMigrationInProgressForBucket = useBucketMigrationProgress()
  const isBucketConvertInProgressForBucket = useBucketConvertProgress()

  let title = 'Move To Trash'
  if (isMigrationInProgressForBucket || isBucketConvertInProgressForBucket) {
    title = 'Media delete is disabled during the migration process'
  } else if (!mediaDeletePermission) {
    title = 'Your role for this bucket does not allow you to delete media.'
  } else if (!selectedMedia.size) {
    title = 'No Media Selected'
  }

  const disabled = !selectedMedia.size || !mediaDeletePermission || isMigrationInProgressForBucket || isBucketConvertInProgressForBucket

  const handleClick = () => {
    if (disabled) return
    modalVar('bucketMediaDelete')
  }

  if (disabled) {
    return null
  }

  return (
    <Tooltip title={title} arrow>
      <PillButton as="span">
        <IconButton
          disabled={disabled}
          color="inherit"
          aria-label="Move To Trash"
          onClick={handleClick}
          id="move-to-trash-pill-button"
          data-testid="buckets-pill-move-to-trash-button"
          sx={{ color: '#fff' }}
        >
          <DeleteOutline />
        </IconButton>
        <span style={{ color: disabled ? 'rgba(0, 0, 0, 0.38)' : '#fff' }}>Delete</span>
      </PillButton>
    </Tooltip>
  )
}
